import type { ReactNode } from 'react';

import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg';

import './CheckItem.scss';

interface ICheckItemProps {
  done: boolean;
  required: boolean;
  label: ReactNode;
  onClick?: () => void;
}

const getMarkerModifier = (done: boolean, required: boolean): string => {
  if (done) return 'check-item__marker--done';
  if (required) return 'check-item__marker--required';
  return 'check-item__marker--todo';
};

const getLabelModifier = (done: boolean, required: boolean): string => {
  if (done) return 'check-item__label--done';
  if (required) return 'check-item__label--required';
  return 'check-item__label--todo';
};

const CheckItem = ({ done, required, label, onClick }: ICheckItemProps) => {
  const isClickable = !done && !!onClick;

  const content = (
    <>
      <span className={`check-item__marker ${getMarkerModifier(done, required)}`} aria-hidden="true">
        {done && <CheckIcon width={8} height={8} />}
      </span>
      <span className={`check-item__label ${getLabelModifier(done, required)}`}>{label}</span>
    </>
  );

  if (isClickable) {
    return (
      <button type="button" className="check-item check-item--clickable" onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className="check-item">{content}</div>;
};

export default CheckItem;
